import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "10. Данные о проектировщике и изготовителе", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, "Введите название проектировщика", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Введите название изготовителя", -1)
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите название проектировщика",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.save_obj.designer_name) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.designer_name]
      ]),
      _hoisted_5,
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите название изготовителя",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeDM.save_obj.manufacturer_name) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.manufacturer_name]
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_7)
  ], 64))
}